import { Folder, Id, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function moveFolder(httpClient: HttpClient) {
  return (folder: Identifiable<Folder>, from: Id, to: Id) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/api/folders/${folder.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        parent: `folder/${to}`,
      },
    });
}

export { moveFolder };
